var scope_0 = require('D:/_bitbucket/com.bykenny.blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8cb25778b535e94051a4a76eaf70d8dc.js').default;
var scope_1 = require('D:/_bitbucket/com.bykenny.blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    